export default function WhyChooseUs() {
  const items = [
    {
      title: "Safe & Secure",
      desc: "Peaceful environment with secure surroundings.",
    },
    {
      title: "Affordable Pricing",
      desc: "Comfortable living spaces that fit your budget.",
    },
    {
      title: "Clean & Maintained",
      desc: "Well-maintained units ready for move-in.",
    },
    {
      title: "Accessible Location",
      desc: "Close to transport, stores, and essentials.",
    },
  ]

  return (
    <section className="py-10 md:py-20 bg-white" id="why-choose-us">
      <div className="max-w-7xl mx-auto px-8">
        <h2 className="text-3xl font-bold text-center text-slate-900 mb-12">
          Why Choose Our Residence
        </h2>

        <div className="grid md:grid-cols-4 gap-8">
          {items.map((item, i) => (
            <div
              key={i}
              className="border border-slate-200 rounded-xl p-6 hover:shadow-lg transition"
            >
              <h3 className="font-semibold text-lg text-slate-900 mb-3">
                {item.title}
              </h3>
              <p className="text-slate-600 text-sm">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
